import { gql } from "@apollo/client";

export const UPDATE_LANGUAGE_PREFERENCE = gql`
  mutation UpdateUserLanguagePreference(
  $userId: ID!
  $selectedLanguage: String!
) {
  updateUserLanguagePreference(
    userId: $userId
    selectedLanguage: $selectedLanguage
  ) {
    currentLanguage
  }
}
`;